/* OURDYSTT — theme.js */

// Nav scroll state
const nav = document.getElementById('main-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// Mobile menu
const hamburger = document.getElementById('nav-hamburger');
const mobileMenu = document.getElementById('nav-mobile-menu');
if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    mobileMenu.classList.toggle('open');
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });
}

function closeMobileMenu() {
  if (mobileMenu) {
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }
}

// Lightbox
function openLightbox(src) {
  const lb = document.getElementById('lightbox');
  const img = document.getElementById('lightbox-img');
  if (!lb || !img) return;
  img.src = src;
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeLightbox() {
  const lb = document.getElementById('lightbox');
  if (!lb) return;
  lb.classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeLightbox();
});

// Scroll reveal
const revealEls = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 55);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach(el => observer.observe(el));
} else {
  revealEls.forEach(el => el.classList.add('visible'));
}

// Inquiry form — client-side enhancement + Formspree AJAX
const form = document.getElementById('inquiry-form');
if (form) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('.submit-btn');
    const success = document.getElementById('form-success');
    const action = form.getAttribute('action');

    // If no Formspree ID configured, show success anyway (demo mode)
    if (!action || action.includes('YOUR_FORM_ID')) {
      if (btn) { btn.textContent = 'Sent'; btn.disabled = true; }
      if (success) success.style.display = 'block';
      return;
    }

    if (btn) { btn.textContent = 'Sending...'; btn.disabled = true; }

    try {
      const data = new FormData(form);
      const res = await fetch(action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      });

      if (res.ok) {
        form.style.opacity = '0.3';
        form.style.pointerEvents = 'none';
        if (success) success.style.display = 'block';
        if (btn) btn.textContent = 'Sent';
      } else {
        if (btn) { btn.textContent = 'Send Inquiry'; btn.disabled = false; }
        alert('Something went wrong. Please try again.');
      }
    } catch {
      if (btn) { btn.textContent = 'Send Inquiry'; btn.disabled = false; }
      alert('Network error. Please try again.');
    }
  });
}
